import { useRetrieveAccessorIdQuery } from "@/service/APIService";
import { useContext, useEffect, useState } from "@/common/hooks";
import { PublicContext } from "@/routes/PublicRoute";
import { ErrorMessage, Spinner } from "@/common/components";

const SetupPassword = () => {
  const { location, skipToken, cloneDeep, Routes, navigate, labels } =
    useContext(PublicContext);

  const [accessorId, setAccessorId] = useState(skipToken);
  const [errors, setErrors] = useState(null)

  const {
    data: accessorData,
    isFetching,
    error,
  } = useRetrieveAccessorIdQuery(accessorId);

  useEffect(() => {
    if (accessorData && accessorData?.customUserId) {
      if(accessorData.isPasswordSet === "Y"){
        setErrors({
          errorMessage : labels?.setupAccount?.alreadySetup
        })
      } else if(accessorData?.customUserId){
        let routeData = cloneDeep(accessorData);
        routeData.setupAccount = true;
        routeData.operatorId = accessorId;
        navigate(Routes.forgotPassword.path, {
          state: routeData,
        });
      }
     
    }
  }, [accessorData]);

  useEffect(() => {
    if(error){
      setErrors({
        errorMessage : labels?.setupAccount?.invalidOperator
      })
    }
  },[error])

  useEffect(() => {
    if (location && location?.search && location?.search?.split("=")) {
      setAccessorId(location.search.split("=")[1]);
    }
  }, []);

  return (
    <section className="container py-5">
      {isFetching && <Spinner />}
      <ErrorMessage error={errors} />
    </section>
  );
};

export default SetupPassword;
